import React, { useEffect, useState } from 'react'
import { Routes, Route, Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Header, Menu, Footer, OffcanvasProvider, Loader } from 'components';
import { Login, Signup } from 'views/Auth';
import Cashbook from 'views/Home/Cashbook'
import Passbook from 'views/Home/Passbook'
import Khatabook from 'views/Home/Khatabook'
import Khata from 'views/Khata'
import Settings from 'views/Settings'
import NoMatch from 'views/NoMatch.js'
import Dummy from 'views/Dummy'
import Reports from 'views/Reports';
import Sahukari from 'views/IframeApps/Sahukari';
import Collection from 'views/IframeApps/Collection';
import CreditProfile from 'views/IframeApps/CreditProfile';
import CreditWallet from 'views/IframeApps/CreditWallet';
import Profile from 'views/IframeApps/Profile';

import Help from 'views/Help';
import Test from 'views/Test';

import OnboardTour from 'views/OnboardTour'
import Onboarding from 'views/Onboarding'
import OnboardingTasksModal from 'components/onboarding-tasks'
import { Toaster, toast } from 'sonner'
import useUniversalStore from 'store/universalStore';
import { auth, api } from 'services';
import PublicKhata from 'views/Khata/p';
import OfflineView from 'components/OfflineView';
import { initAnalytics, identifyUser } from "./lib/analytics";

initAnalytics();

function App() {
    const location = useLocation();
    const { user, fetchInitialData, userBasic } = useUniversalStore((state) => state);
    const navigate = useNavigate();
    const showFooterPaths = ['/settings', '/profile', '/help'];
    const shouldShowFooter = showFooterPaths.includes(location.pathname);
    const [isOnline, setOnline] = useState(navigator.onLine);
    const [loading, setLoading] = useState(0);

    useEffect(() => {
        checkInternetConnection();
        fetchInitialData();
    }, []);

    useEffect(() => {
        const businessName = userBasic?.business?.name;
        if (user) {
            identifyUser(user?.get("username"), {
                $first_name: businessName || user?.get("username"),
                $email: user?.get("email"),
                phone: user?.get("username")
            });
        }
        if (user && !businessName) navigate('/signup');
    }, [userBasic, user]);

    const checkInternetConnection = async () => {
        const handleOnline = () => setOnline(navigator.onLine);
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOnline);

        //progress increment
        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            setLoading(progress);
            if (progress >= 100) {
                clearInterval(interval);
            }
        }, 300);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOnline);
            clearInterval(interval);
        }
    };

    if (!isOnline) {
        return <OfflineView />
    }

    if (loading < 100) {
        return <Loader loading={loading} />
    }

    return (
        <OffcanvasProvider>
            <Toaster position="bottom-center" theme="dark" richColors visibleToasts={1} />
            {/* <OnboardTour /> */}
            {/* <OnboardingTasksModal /> */}
            {/* <Onboarding /> */}
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/khatabook" element={<PrivateRoute><Khatabook /></PrivateRoute>} />
                <Route path="/" element={<PrivateRoute><Cashbook /></PrivateRoute>} />
                <Route path="/passbook" element={<PrivateRoute><Passbook /></PrivateRoute>} />
                <Route path="/p">
                    <Route path=":id" element={<PublicKhata />} />
                </Route>
                <Route path="/dummy" element={<PrivateRoute><Dummy /></PrivateRoute>} />
                <Route path="/help" element={<PrivateRoute><Help /></PrivateRoute>} />
                <Route path="/reports/*" element={<PrivateRoute><Reports /></PrivateRoute>} />
                <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
                <Route path="/test" element={<PrivateRoute><Test /></PrivateRoute>} />
                <Route path="/sahukari" element={<PrivateRoute><Sahukari /></PrivateRoute>} />
                <Route path="/collections" element={<PrivateRoute><Collection /></PrivateRoute>} />
                <Route path="/credit-profile" element={<PrivateRoute><CreditProfile /></PrivateRoute>} />
                <Route path="/credit-wallet" element={<PrivateRoute><CreditWallet /></PrivateRoute>} />
                {/* <Route path="/profile" element={<PrivateRoute><Profile />{' '}</PrivateRoute>} /> */}
                <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                <Route path="*" element={<NoMatch />} />
            </Routes>
            {shouldShowFooter && <Footer />}
        </OffcanvasProvider>
    )
};

const PrivateRoute = ({ children }) => {
    const user = auth.fetchUser();
    if (!user) {
        return <Navigate to="/login" />;
    }
    return (
        <>
            <Header />
            {children}
        </>
    );
}

export default App
